import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

import { ESuburbanWCType } from '../../../../../../../json_query';

export interface ISuburbanBathroomProps {
  value: ESuburbanWCType;
  onChange(type: ESuburbanWCType): void;
}

const VALUES: { label: string; value: ESuburbanWCType }[] = [
  { label: 'Любой', value: ESuburbanWCType.Any },
  { label: 'В доме', value: ESuburbanWCType.Inside },
  { label: 'На улице', value: ESuburbanWCType.Outside },
];

export const SuburbanBathroom: React.StatelessComponent<ISuburbanBathroomProps> = ({ value, onChange }) => (
  <DropdownField placeholder="Любой" value={value} onValueChange={onChange} values={VALUES} />
);
